import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const BloodPressurePage = lazy(() => import("./BloodPressurePage"));

const BloodPressurePageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <BloodPressurePage />
    </Suspense>
  );
};

export default BloodPressurePageLazy;
